import type { FormApi } from 'final-form';

import { Currency } from '@swf/core/enums';
import type {
  GameStructure,
  HGCreateClubTournamentReply,
  HGGetClubTournStructuresReply
} from '@swf/generated/types/api/v0/SwHomeGames';

import {
  TXTCLI_Hyper,
  TXTCLI_Knockout,
  TXTCLI_No_Limit,
  TXTCLI_Play_Money,
  TXTCLI_Pot_Limit,
  TXTCLI_Progressive_Knockout,
  TXTCLI_Regular,
  TXTCLI_Regular___1_rebuyX_1_addon,
  TXTCLI_Regular___2_rebuysX_1_addon,
  TXTCLI_Regular___2_rebuysX_no_addon,
  TXTCLI_Regular___no_rebuys,
  TXTCLI_Regular___unlimited_rebuysX_1__ELL_1,
  TXTCLI_Shootout,
  TXTCLI_Turbo
} from './common.messages.json';

export interface FormValues {
  gameName: string;
  startDate: string;
  startTime: string;
  repeat: boolean;
  repeatDate: string;
  notes: string;
  handType: GameStructure['handType'];
  potStruct: GameStructure['potTypes'];
  tableSize: number;
  currency: Currency | string;
  buyIn: string;
  startingChips: number[];
  payout: string;
  tournFormat: string;
  tournLateRegLevel: number;
  levelLength: number;
  tournReentry: number;
  tournSyncBreaks: boolean;
  enableVideoChat: boolean;
}

export interface Form {
  form: FormApi<FormValues>;
}

export enum ModalPages {
  'MainInfo',
  'GameDetails',
  'MoreDetails'
}

export enum ModalPagesRoutes {
  '#create-tournament-flow.main-info',
  '#create-tournament-flow.game-details',
  '#create-tournament-flow.more-details'
}

export const totalPages = Object.keys(ModalPages).length / 2 - 1;

export const ModalPagesNames = Object.values(ModalPages).filter((val) => isNaN(Number(val)));

export interface TournamentWizardContext {
  tournamentStructuresResponse: {
    data: HGGetClubTournStructuresReply;
  };
  createClubTournamentResponse: {
    data: HGCreateClubTournamentReply;
    error: string;
  };
  loading: boolean;
  loadingCreateTournament: boolean;
}

export const PlayMoney = { text: TXTCLI_Play_Money.defaultMessage, value: Currency.PlayMoney };

export const PotTypeDesc = {
  STRUCT_NO_LIMIT: TXTCLI_No_Limit.defaultMessage,
  STRUCT_POT_LIMIT: TXTCLI_Pot_Limit.defaultMessage
};

export const SupportedTournamentSpeed = {
  HG_TOURN_SPEED_REGULAR: 10,
  HG_TOURN_SPEED_HYPER: 3,
  HG_TOURN_SPEED_TURBO: 5
};

export const SupportedTournamentSpeedText = {
  HG_TOURN_SPEED_REGULAR: TXTCLI_Regular.defaultMessage,
  HG_TOURN_SPEED_HYPER: TXTCLI_Hyper.defaultMessage,
  HG_TOURN_SPEED_TURBO: TXTCLI_Turbo.defaultMessage
};

export const SupportedTournamentFormatText = {
  REGULAR: TXTCLI_Regular___no_rebuys.defaultMessage,
  REBUY_1R1A: TXTCLI_Regular___1_rebuyX_1_addon.defaultMessage,
  REBUY_2R1A: TXTCLI_Regular___2_rebuysX_1_addon.defaultMessage,
  REBUY_2RNOA: TXTCLI_Regular___2_rebuysX_no_addon.defaultMessage,
  REBUY: TXTCLI_Regular___unlimited_rebuysX_1__ELL_1.defaultMessage,
  KNOCKOUT: TXTCLI_Knockout.defaultMessage,
  PROGRESSIVE_KO: TXTCLI_Progressive_Knockout.defaultMessage,
  SHOOTOUT: TXTCLI_Shootout.defaultMessage
};
